import type { TranslateDictionary } from './en.js';

export const Uk: TranslateDictionary = {
  'Start airplay': 'Запустити AirPlay',
  'Stop airplay': 'Зупинити AirPlay',
  Audio: 'Аудіо',
  Captions: 'Субтитри',
  'Enable captions': 'Увімкнути субтитри',
  'Disable captions': 'Вимкнути субтитри',
  'Start casting': 'Розпочати трансляцію',
  'Stop casting': 'Зупинити трансляцію',
  'Casting to {device}': 'Трансляція на {device}',
  'Enter fullscreen mode': 'На повний екран',
  'Exit fullscreen mode': 'Вийти з повного екрану',
  Mute: 'Вимкнути звук',
  Unmute: 'Увімкнути звук',
  'Enter picture in picture mode': 'Увімкнути режим картинка-в-картинці',
  'Exit picture in picture mode': 'Вийти з режиму картинка-в-картинці',
  Play: 'Відтворити',
  Pause: 'Призупинити',
  'Playback rate': 'Швидкість відтворення',
  'Playback rate {playbackRate}': 'Швидкість відтворення {playbackRate}',
  Quality: 'Якість',
  'Seek backward': 'Перемотати назад',
  'Seek forward': 'Перемотати вперед',
  Settings: 'Налаштування',
  Auto: 'Авто',
  'audio player': 'аудіо програвач',
  'video player': 'відео програвач',
  volume: 'Гучність',
  seek: 'Шукати',
  'closed captions': 'Субтитри',
  'current playback rate': 'поточна швидкість відтворення',
  'playback time': 'час відтворення',
  'media loading': 'завантаження медіа',
  settings: 'Налаштування',
  'audio tracks': 'аудіодоріжки',
  quality: 'Якість',
  play: 'відтворити',
  pause: 'призупинити',
  mute: 'вимкнути звук',
  unmute: 'увімкнути звук',
  'chapter: {chapterName}': 'розділ: {chapterName}',
  live: 'наживо',
  Off: 'Вимкнено',
  'start airplay': 'запустити AirPlay',
  'stop airplay': 'зупинити AirPlay',
  'start casting': 'розпочати трансляцію',
  'stop casting': 'зупинити трансляцію',
  'enter fullscreen mode': 'на повний екран',
  'exit fullscreen mode': 'вийти з повного екрану',
  'enter picture in picture mode': 'увімкнути режим картинка-в-картинці',
  'exit picture in picture mode': 'вийти з режиму картинка-в-картинці',
  'seek to live': 'перейти до прямого ефіру',
  'playing live': 'відтворення наживо',
  'seek back {seekOffset} seconds': 'перемотати на {seekOffset} с назад',
  'seek forward {seekOffset} seconds': 'перемотати на {seekOffset} с вперед',
  'Network Error': 'Помилка мережі',
  'Decode Error': 'Помилка декодування',
  'Source Not Supported': 'Джерело не підтримується',
  'Encryption Error': 'Помилка шифрування',
  'A network error caused the media download to fail.':
    'Помилка мережі призвела до збою завантаження медіа.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Помилка медіа призвела до переривання відтворення. Медіа може бути пошкоджено або ваш браузер не підтримує цей формат.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Сталася непідтримувана помилка. Сервер або мережа не працюють, або ваш браузер не підтримує цей формат.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Медіа зашифровано і немає ключів для його розшифровки.',
};
